define([
	"dojo/_base/declare",
	"csi/gallery/Widget",
	"./VersionView"
], function(declare,Widget,VersionView) {
	return declare([Widget,VersionView], { });
});